module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon",
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64fc3dc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/input-group-addon.vue
// module id = 243
// module chunks = 0